import React from 'react';
import { AlertTriangleIcon } from 'lucide-react';
export function EmergencyFooter() {
  return <section className="bg-[#F7F9FC] py-12 md:py-16 border-t border-light-border" aria-label="Emergency Information" data-id="element-57">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center space-y-6" data-id="element-58">
        <div className="flex flex-col sm:flex-row items-center justify-center gap-3 text-red-600 font-bold text-lg md:text-xl" data-id="element-59">
          <AlertTriangleIcon className="h-6 w-6" aria-hidden="true" data-id="element-60" />
          <p data-id="element-61">For all medical emergencies, call 911 immediately.</p>
        </div>

        <div className="w-16 h-px bg-gray-300 mx-auto" aria-hidden="true" data-id="element-62" />

        <p className="text-gray-600 text-base md:text-lg" data-id="element-63">
          To reach a provider after hours, call our main number{' '}
          <strong className="text-navy-500" data-id="element-64">(718) 555-0100</strong> to be
          connected to the on-call physician.
        </p>

        <div className="w-16 h-px bg-gray-300 mx-auto" aria-hidden="true" data-id="element-65" />

        <p className="text-navy-500 font-semibold italic text-lg md:text-xl font-script" data-id="element-66">
          We will never turn anyone away.
        </p>
      </div>
    </section>;
}